var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8989_34415",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    width: 24,
    height: 24,
    transform: "rotate(90 24.5 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8989_34415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14866 14.7004L12.4987 18.0504L15.8487 14.7004L9.14866 14.7004ZM8.74866 15.2754C8.51532 15.0421 8.46115 14.7712 8.58616 14.4629C8.71116 14.1546 8.94032 14.0004 9.27366 14.0004L15.7237 14.0004C16.057 14.0004 16.2862 14.1546 16.4112 14.4629C16.5362 14.7712 16.482 15.0421 16.2487 15.2754L13.0237 18.5004C12.9403 18.5837 12.857 18.6421 12.7737 18.6754C12.6903 18.7087 12.5987 18.7254 12.4987 18.7254C12.3987 18.7254 12.307 18.7087 12.2237 18.6754C12.1403 18.6421 12.057 18.5837 11.9737 18.5004L8.74866 15.2754ZM8.74866 8.72539L11.9737 5.50039C12.057 5.41706 12.1403 5.35872 12.2237 5.32539C12.307 5.29206 12.3987 5.27539 12.4987 5.27539C12.5987 5.27539 12.6903 5.29206 12.7737 5.32539C12.857 5.35872 12.9403 5.41706 13.0237 5.50039L16.2487 8.72539C16.482 8.95872 16.5362 9.22956 16.4112 9.53789C16.2862 9.84622 16.057 10.0004 15.7237 10.0004L9.27366 10.0004C8.94032 10.0004 8.71116 9.84622 8.58616 9.53789C8.46116 9.22956 8.51532 8.95872 8.74866 8.72539Z",
    fill: "#535B5F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort_up.3153a04a783f5af209ad2ffd18bec71c.svg";
export { ForwardRef as ReactComponent };